<template>
  <div>
    <div class="card card-default">
      <div class="card-header">
        <h3>Run a task</h3>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <input
              class="form-control"
              v-model="searchText"
              placeholder="Search"
            />
          </div>
        </div>
        <div class="row row-spacing">
          <div class="col-md-12">
            <div class="table-responsive table-bordered">
              <table class="table">
                <thead>
                  <tr>
                    <th>Description</th>
                    <th>Name</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="taskDefinition in filterAvailableTasks"
                    :key="taskDefinition.taskDefinitionNumber"
                  >
                    <td>{{ taskDefinition.description }}</td>
                    <td>
                      <small>{{ taskDefinition.name }}</small>
                    </td>
                    <td class="text-center">
                      <button
                        class="btn btn-primary m-1"
                        type="button"
                        @click="openRunTaskNowModal(taskDefinition)"
                      >
                        <i class="fa fa-bolt"></i> Run Now
                      </button>
                      <button
                        class="btn btn-secondary m-1"
                        type="button"
                        @click="openScheduleTaskModal(taskDefinition)"
                        :disabled="taskDefinition.hasContentParams"
                        :title="taskDefinition.hasContentParams ? 'Tasks with file uploads cannot be scheduled' : 'Schedule this task'"
                      >
                        <i class="fa fa-clock"></i> Schedule
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :title="'Run ' + selectedTaskDefinition.name + ' task now'"
      ref="runNewTaskModal"
      size="modal-lg"
      save-text="Run Task"
      @save="runTaskNow()"
    >
      <h4>Required</h4>
      <table
        class="table table-bordered"
        v-if="selectedTaskDefinition.requiredInputParams.length > 0"
      >
        <tbody>
          <tr
            v-for="inputParam in selectedTaskDefinition.requiredInputParams"
            :key="inputParam.taskParameterDefinitionNumber"
          >
            <td>
              <strong>{{ inputParam.description }}</strong>
            </td>
            <td>
              <input
                type="checkbox"
                v-model="inputParam.value"
                v-if="inputParam.type == 'BOOLEAN'"
              />
              <input
                type="text"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'STRING'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'INT'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DOUBLE'"
                class="form-control"
              />
              <input
                type="file"
                @change="fileSelected($event, inputParam)"
                v-else-if="inputParam.type == 'CONTENT'"
                class="form-control"
              />
              <DateInput
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DATE'"
              />
              <strong style="color: red" v-else
                >Param type {{ inputParam.type }} not supported</strong
              >
              <strong style="color: red" v-if="inputParam.hasError"
                >{{ inputParam.name }} is required</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>No Required Parameters</p>
      <hr />
      <h5>Optional</h5>
      <table
        class="table table-bordered"
        v-if="selectedTaskDefinition.optionalInputParams.length > 0"
      >
        <tbody>
          <tr
            v-for="inputParam in selectedTaskDefinition.optionalInputParams"
            :key="inputParam.taskParameterDefinitionNumber"
          >
            <td>
              <p>{{ inputParam.description }}</p>
            </td>
            <td>
              <input
                type="checkbox"
                v-model="inputParam.value"
                v-if="inputParam.type == 'BOOLEAN'"
              />
              <input
                type="text"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'STRING'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'INT'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DOUBLE'"
                class="form-control"
              />
              <input
                type="file"
                @change="fileSelected($event, inputParam)"
                v-else-if="inputParam.type == 'CONTENT'"
                class="form-control"
              />
              <DateInput
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DATE'"
              />
              <strong style="color: red" v-else
                >Param type {{ inputParam.type }} not supported</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>No Optional Parameters</p>
    </modal>

    <!-- Schedule Task Modal -->
    <modal
      :title="'Schedule ' + selectedTaskDefinition.name + ' task'"
      ref="scheduleTaskModal"
      size="modal-lg"
      save-text="Create Schedule"
      @save="scheduleTask()"
    >
      <h4>Schedule</h4>
      <ScheduleEditor v-model="taskSchedule" />

      <hr />

      <h4>Required Parameters</h4>
      <table
        class="table table-bordered"
        v-if="scheduleRequiredParams.length > 0"
      >
        <tbody>
          <tr
            v-for="inputParam in scheduleRequiredParams"
            :key="inputParam.taskParameterDefinitionNumber"
          >
            <td>
              <strong>{{ inputParam.description }}</strong>
            </td>
            <td>
              <input
                type="checkbox"
                v-model="inputParam.value"
                v-if="inputParam.type == 'BOOLEAN'"
              />
              <input
                type="text"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'STRING'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'INT'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DOUBLE'"
                class="form-control"
              />
              <DateInput
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DATE'"
              />
              <strong style="color: red" v-else
                >Param type {{ inputParam.type }} not supported</strong
              >
              <strong style="color: red" v-if="inputParam.hasError"
                >{{ inputParam.name }} is required</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>No Required Parameters</p>

      <hr />

      <h5>Optional Parameters</h5>
      <table
        class="table table-bordered"
        v-if="scheduleOptionalParams.length > 0"
      >
        <tbody>
          <tr
            v-for="inputParam in scheduleOptionalParams"
            :key="inputParam.taskParameterDefinitionNumber"
          >
            <td>
              <p>{{ inputParam.description }}</p>
            </td>
            <td>
              <input
                type="checkbox"
                v-model="inputParam.value"
                v-if="inputParam.type == 'BOOLEAN'"
              />
              <input
                type="text"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'STRING'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'INT'"
                class="form-control"
              />
              <input
                type="number"
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DOUBLE'"
                class="form-control"
              />
              <DateInput
                v-model="inputParam.value"
                v-else-if="inputParam.type == 'DATE'"
              />
              <strong style="color: red" v-else
                >Param type {{ inputParam.type }} not supported</strong
              >
            </td>
          </tr>
        </tbody>
      </table>
      <p v-else>No Optional Parameters</p>
    </modal>
  </div>
</template>

<script>
import Modal from "@/components/GeneralComponents/Modal";
import DateInput from "@/components/GeneralComponents/InputControls/DateInput";
import ScheduleEditor from "@/components/GeneralComponents/ScheduleEditor";
export default {
  components: {
    Modal,
    DateInput,
    ScheduleEditor,
  },
  computed: {
    filterAvailableTasks() {
      if (this.searchText && this.searchText.length > 0) {
        return this.taskDefinitions.filter(
          (t) =>
            t.name.toLowerCase().indexOf(this.searchText.toLowerCase()) != -1 ||
            t.description
              .toLowerCase()
              .indexOf(this.searchText.toLowerCase()) != -1
        );
      } else {
        return this.taskDefinitions;
      }
    },
  },
  data() {
    return {
      taskDefinitions: [],
      searchText: null,
      selectedTaskDefinition: {
        requiredInputParams: [],
        optionalInputParams: [],
        notifyEmail: {},
      },
      taskSchedule: null,
      scheduleRequiredParams: [],
      scheduleOptionalParams: [],
    };
  },
  mounted() {
    this.$root.$emit("SET_PAGE_TITLE", "Run New Task");

    this.$http.get(this.$config.aimsAPI + "tasks/definitions").then(
      (response) => {
        this.taskDefinitions = response.data;
        this.taskDefinitions.forEach((taskDef) => {
          this.$http
            .get(
              this.$config.aimsAPI +
                "tasks/definitions/" +
                taskDef.name +
                "/params/input"
            )
            .then(
              (paramResponse) => {
                const hasContent = paramResponse.data.some(
                  (p) => p.type === "CONTENT"
                );
                this.$set(taskDef, "hasContentParams", hasContent);
              },
              () => {
                this.$set(taskDef, "hasContentParams", false);
              }
            );
        });
      },
      (error) => {
        console.error(error);
        this.showError("Error Fetching Tasks", error);
      }
    );
  },
  methods: {
    openRunTaskNowModal(taskDefinition) {
      this.$set(taskDefinition, "requiredInputParams", []);
      this.$set(taskDefinition, "optionalInputParams", []);
      this.selectedTaskDefinition = taskDefinition;
      this.$http
        .get(
          this.$config.aimsAPI +
            "tasks/definitions/" +
            taskDefinition.name +
            "/params/input"
        )
        .then(
          (response) => {
            this.selectedTaskDefinition.requiredInputParams =
              response.data.filter((r) => r.required == true);
            this.selectedTaskDefinition.optionalInputParams =
              response.data.filter((r) => r.required == false);
            this.$refs.runNewTaskModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Task Parameters", error);
          }
        );
    },
    fileSelected(event, inputParam) {
      const fileSelected = event.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(fileSelected);
      reader.onload = function () {
        let encoded = reader.result.toString().replace(/^data:(.*,)?/, "");
        if (encoded.length % 4 > 0) {
          encoded += "=".repeat(4 - (encoded.length % 4));
        }
        inputParam.value = encoded;
        inputParam.meta = fileSelected.name;
      };
      reader.onerror = function (error) {
        console.error("Error selecting file: ", error);
        this.showError("Error selecting file");
      };
    },
    runTaskNow() {
      this.selectedTaskDefinition.requiredInputParams.forEach((rp) => {
        if (!rp.value || rp.value == "" || rp.value.length == 0) {
          this.$set(rp, "hasError", true);
        }
      });

      const paramValues = [];
      this.selectedTaskDefinition.requiredInputParams.forEach((rp) => {
        paramValues.push({
          name: rp.name,
          type: rp.type,
          value: rp.value,
          meta: rp.meta,
        });
      });

      this.selectedTaskDefinition.optionalInputParams.forEach((rp) => {
        paramValues.push({
          name: rp.name,
          type: rp.type,
          value: rp.value,
          meta: rp.meta,
        });
      });

      if (
        this.selectedTaskDefinition.requiredInputParams.filter(
          (rp) => rp.hasError == true
        ).length === 0
      ) {
        this.$refs.runNewTaskModal.isLoading();
        
        this.$http
          .post(
            this.$config.aimsAPI +
              "tasks/definitions/run?taskName=" +
              this.selectedTaskDefinition.name +
              "&runInForeground=" +
              this.$config.runInForeground,
            paramValues
          )
          .then(
            () => {
              this.$refs.runNewTaskModal.close();
              this.showSuccess("Task queued successfully");
              this.$router.push({
                name: "tasklist",
              });
            },
            (error) => {
              console.error(error);
              this.showError("Error Running Task", error);
            }
          );
      }
    },
    openScheduleTaskModal(taskDefinition) {
      this.$set(taskDefinition, "requiredInputParams", []);
      this.$set(taskDefinition, "optionalInputParams", []);
      this.selectedTaskDefinition = taskDefinition;
      // Set default schedule to current time (daily at current hour/minute)
      const now = new Date();
      this.taskSchedule = {
        dayOfMonth: "any",
        dayOfWeek: "any",
        month: "any",
        hour: now.getHours(),
        minute: Math.floor(now.getMinutes() / 5) * 5 // Round to nearest 5 minutes
      };
      this.scheduleRequiredParams = [];
      this.scheduleOptionalParams = [];

      this.$http
        .get(
          this.$config.aimsAPI +
            "tasks/definitions/" +
            taskDefinition.name +
            "/params/input"
        )
        .then(
          (response) => {
            // Filter out CONTENT type params for scheduling
            const nonContentParams = response.data.filter(
              (p) => p.type !== "CONTENT"
            );
            this.scheduleRequiredParams = nonContentParams.filter(
              (r) => r.required === true
            );
            this.scheduleOptionalParams = nonContentParams.filter(
              (r) => r.required === false
            );
            this.$refs.scheduleTaskModal.open();
          },
          (error) => {
            console.error(error);
            this.showError("Error Fetching Task Parameters", error);
          }
        );
    },
    scheduleTask() {
      // Validate schedule is configured
      if (!this.taskSchedule) {
        this.showError("Please configure a schedule");
        return;
      }

      // Validate required params
      this.scheduleRequiredParams.forEach((rp) => {
        if (!rp.value || rp.value === "" || rp.value.length === 0) {
          this.$set(rp, "hasError", true);
        } else {
          this.$set(rp, "hasError", false);
        }
      });

      if (
        this.scheduleRequiredParams.filter((rp) => rp.hasError === true)
          .length > 0
      ) {
        return;
      }

      // Build job setup parameters
      const parameters = {};
      this.scheduleRequiredParams.forEach((rp) => {
        if (rp.value !== undefined && rp.value !== "") {
          parameters[rp.name] = String(rp.value);
        }
      });
      this.scheduleOptionalParams.forEach((rp) => {
        if (rp.value !== undefined && rp.value !== "") {
          parameters[rp.name] = String(rp.value);
        }
      });

      // First get an empty ScheduledTask template
      this.$refs.scheduleTaskModal.isLoading();

      this.$http
        .get(this.$config.aimsAPIv3 + "schedule/tasks/empty")
        .then(
          (response) => {
            const scheduledTask = response.data;
            scheduledTask.taskName = this.selectedTaskDefinition.name;
            scheduledTask.schedule = JSON.stringify(this.taskSchedule);
            scheduledTask.enabled = true;
            scheduledTask.jobSetup = JSON.stringify({ parameters });

            // Create the scheduled task
            return this.$http.post(
              this.$config.aimsAPIv3 + "schedule/tasks",
              scheduledTask
            );
          }
        )
        .then(
          () => {
            this.$refs.scheduleTaskModal.close();
            this.showSuccess("Task scheduled successfully");
            this.$router.push({
              name: "scheduledtasks",
            });
          },
          (error) => {
            console.error(error);
            this.showError("Error Scheduling Task", error);
          }
        );
    }
  },
};
</script>
